export default __webpack_public_path__ + "static/media/affordability.6d163f7a.png";